"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const __1 = require("..");
const styles_1 = __importDefault(require("./styles"));
const Copyright = (_a) => {
    var { scale = 1, reserveFill, isPositionAbsolute } = _a, rest = __rest(_a, ["scale", "reserveFill", "isPositionAbsolute"]);
    const classes = styles_1.default({ scale, reserveFill, isPositionAbsolute });
    return (react_1.default.createElement(core_1.Grid, { alignItems: "center", className: classes.container, container: true, direction: "row", justify: "center" },
        react_1.default.createElement(core_1.Typography, Object.assign({ className: classes.text }, rest), "Powered by"),
        react_1.default.createElement(__1.CompanyLogo, Object.assign({ company: "zeals", reserveFill: reserveFill, scale: scale }, rest))));
};
exports.default = Copyright;
